export const IMAGES = {
  heroInfra:
    "https://images.unsplash.com/photo-1600730424902-a3a3be6af112?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmFsJTIwc2t5c2NyYXBlciUyMGNvbmNyZXRlJTIwc3RlZWwlMjBhcmNoaXRlY3R1cmUlMjBicnV0YWxpc3QlMjBtb25vbGl0aGljfGVufDB8fHx8MTc5MjA2MjcwNHww&ixlib=rb-4.1.0&q=85",
  infraFacade:
    "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZyUyMGdlb21ldHJ5fGVufDB8fHx8MTc5MjA2MjcxMHww&ixlib=rb-4.1.0&q=85",
  infraTower:
    "https://images.unsplash.com/photo-1662906047226-971b484f5056?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmVsJTIwc2t5c2NyYXBlciUyMGNvbmNyZXRlJTIwc3RlZWwlMjBhcmNoaXRlY3R1cmUlMjBicnV0YWxpc3QlMjBtb25vbGl0aGljfGVufDB8fHx8MTc5MjA2MjcwNHww&ixlib=rb-4.1.0&q=85",
  techServer:
    "https://images.unsplash.com/photo-1782094673136-5198a372980c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxkYXRhJTIwY2VudGVyJTIwc2VydmVyJTIwcm9vbXxlbnwwfHx8fDE3OTIwNjI3MTB8MA&ixlib=rb-4.1.0&q=85",
  techEngineer:
    "https://images.unsplash.com/photo-1785682117346-4b114502e9b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxkYXRhJTIwY2VudGVyJTIwc2VydmVyJTIwcm9vbXxlbnwwfHx8fDE3OTIwNjI3MTB8MA&ixlib=rb-4.1.0&q=85",
  techFiber:
    "https://images.unsplash.com/photo-1744868562210-fffb7fa882d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxkYXRhJTIwY2VudGVyJTIwc2VydmVyJTIwcm9vbXxlbnwwfHx8fDE3OTIwNjI3MTB8MA&ixlib=rb-4.1.0&q=85",
  textureBronze:
    "https://images.unsplash.com/photo-1548248823-ce16a73b6d49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZyUyMGdlb21ldHJ5fGVufDB8fHx8MTc5MjA2MjcxMHww&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_ITEMS = [
  "STRATEGIC INFRASTRUCTURE",
  "TIER-1 AMC STATUS",
  "NSE · BSE · MCX ECOSYSTEMS",
  "99.999% CLUSTER UPTIME",
  "INSTITUTIONAL ASSET MANAGEMENT",
  "ENTERPRISE SOFTWARE ENGINEERING",
  "TURNKEY COMMISSIONING",
  "MISSION-CRITICAL SYSTEMS",
];

export const STATS = [
  { value: 5000, prefix: "₹", suffix: "+ Cr", decimals: 0, label: "Assets Under Stewardship" },
  { value: 99.999, prefix: "", suffix: "%", decimals: 3, label: "Financial Cluster Uptime" },
  { value: 3, prefix: "", suffix: "", decimals: 0, label: "Exchange Ecosystems — NSE · BSE · MCX" },
  { value: 24, prefix: "", suffix: "/7", decimals: 0, label: "Mission-Critical AMC Coverage" },
];

export const DIVISIONS = {
  infra: {
    number: "01",
    path: "/infrastructure",
    title: "Strategic Infrastructure & Real Estate",
    shortTitle: "Strategic Infrastructure",
    tagline: "Architectural Precision & High-Value Asset Management",
    accent: "#38BDF8",
    heroImage: IMAGES.infraFacade,
    description:
      "Full-spectrum project development and colonization — from land assembly to commissioning — executed with the discipline of an institutional asset house.",
    services: [
      {
        title: "Large-Scale Construction & Development",
        description: "Executing residential, commercial, and industrial projects with architectural precision.",
        image: IMAGES.infraFacade,
      },
      {
        title: "Institutional Asset Management",
        description: "Strategic acquisition, leasing, and management of high-value immovable properties.",
        image: IMAGES.infraTower,
      },
      {
        title: "Turnkey Renovation & Commissioning",
        description: "End-to-end infrastructure renovation and project commissioning on a contract basis.",
        image: IMAGES.heroInfra,
      },
    ],
    standard:
      "Full-spectrum project development and colonization, delivered under institutional governance and uncompromising structural standards.",
  },
  tech: {
    number: "02",
    path: "/technology",
    title: "Advanced Intelligence & Digital Systems",
    shortTitle: "Advanced Intelligence",
    tagline: "Mission-Critical Enterprise Server Maintenance & Data Infrastructure",
    accent: "#10B981",
    heroImage: IMAGES.techServer,
    description:
      "Tier-1 maintenance and engineering for the systems that cannot fail — financial market ecosystems, trading clusters, and complex data environments.",
    services: [
      {
        title: "Mission-Critical Server Maintenance",
        description:
          "Tier-1 AMC services for financial ecosystems (NSE, BSE, MCX) and high-frequency trading server clusters.",
        image: IMAGES.techEngineer,
      },
      {
        title: "System Integration & IT Consultancy",
        description: "Providing technical consultancy and integrated solutions for complex data processing environments.",
        image: IMAGES.techFiber,
      },
      {
        title: "Enterprise Software Engineering",
        description: "Development and customization of specialized applications and software programs.",
        image: IMAGES.techServer,
      },
    ],
    standard:
      "Excellence in data processing and system integration — focused on backend technical systems, excluding web-page designing.",
  },
};

export const CONTACT = {
  headOffice: "Crestmont Enterprises Private Limited",
  address: "Lodha Signet 1, Unit No. 825, Premier Colony, Ground, Kalyan, Thane, Mangaon — 421204",
  operations: "National Infrastructure & IT Solutions",
};

export const INQUIRY_TYPES = [
  { value: "project_development", label: "Project Development" },
  { value: "asset_management", label: "Asset Management" },
  { value: "amc_maintenance", label: "AMC & Server Maintenance" },
  { value: "it_consultancy", label: "System Integration & Consultancy" },
  { value: "software_engineering", label: "Enterprise Software Engineering" },
  { value: "general", label: "General Enquiry" },
];
